import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { ContainerDefaultStyling, ContainerProps } from "./types";

const CONTAINER_DEFAULT_STYLING: ContainerDefaultStyling = {
  padding: "~px-4/12 ~py-8/16",
  margin: "mx-auto",
  maxWidth: "max-w-lg",
};

function Container<E extends React.ElementType = "div">({
  as,
  asChild = false,
  padding = CONTAINER_DEFAULT_STYLING.padding,
  margin = CONTAINER_DEFAULT_STYLING.margin,
  maxWidth = CONTAINER_DEFAULT_STYLING.maxWidth,
  className,
  ...props
}: ContainerProps<E>) {
  const Component = resolveElement(asChild, as, "div");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Container] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(maxWidth, padding, margin, className, classes)}
      {...native}
    />
  );
}

export default Container;
